// src/lib/sms.js
// NSV SMS Notification Library — powered by Twilio via Netlify function
// ✅ A2P 10DLC compliant — all messages include "Reply STOP to opt out"

async function sendSMS(to, message) {
  if (!to) return
  try {
    const res = await fetch('/.netlify/functions/send-sms', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ to, message }),
    })
    if (!res.ok) {
      const err = await res.json()
      console.error('❌ SMS failed:', err)
    } else {
      console.log('✅ SMS sent to:', to)
    }
  } catch (err) {
    console.error('❌ SMS error:', err)
  }
}

// ── 1. Notary assignment SMS ──────────────────────────────────
export async function smsNotaryAssignment({ notary_name, notary_phone, job_number, service_name, address, appointment, pay }) {
  await sendSMS(notary_phone,
    `⚡ NSV ASSIGNMENT — ${job_number}\n` +
    `Service: ${service_name}\n` +
    `Location: ${address}\n` +
    `Appointment: ${appointment || 'TBD'}\n` +
    `Your Pay: $${pay}\n\n` +
    `ACCEPT or DECLINE:\nhttps://notarysigningvault.com/notary/available\n\n` +
    `Reply STOP to opt out.`
  )
}

// ── 2. Client order confirmation SMS ─────────────────────────
export async function smsClientConfirmation({ client_name, client_phone, job_number, service_name }) {
  await sendSMS(client_phone,
    `✅ NSV Order Confirmed — ${job_number}\n` +
    `Service: ${service_name}\n` +
    `We are finding your certified notary and will notify you shortly!!\n\n` +
    `Track your order:\nhttps://notarysigningvault.com/client\n\n` +
    `Reply STOP to opt out.`
  )
}

// ── 3. Notary accepted — client notification SMS ──────────────
export async function smsNotaryAssigned({ client_phone, notary_name, notary_phone, job_number, appointment }) {
  await sendSMS(client_phone,
    `🎉 Your notary has been assigned — ${job_number}\n` +
    `Notary: ${notary_name}\n` +
    `📞 ${notary_phone || 'See portal'}\n` +
    `Appointment: ${appointment || 'TBD'}\n\n` +
    `Track your order:\nhttps://notarysigningvault.com/client\n\n` +
    `Reply STOP to opt out.`
  )
}

// ── 4. Job completed SMS to client ───────────────────────────
// ✅ Internal rating drives notary Ranks & Rewards system
// ⭐ External Google + Yelp reviews drive social proof
export async function smsJobCompleted({ client_phone, job_number, service_name }) {
  await sendSMS(client_phone,
    `🏆 Signing Completed — ${job_number}\n` +
    `Service: ${service_name}\n\n` +
    `Rate your notary:\nhttps://notarysigningvault.com/client\n\n` +
    `⭐ Loved your service? Leave us a review!!\n` +
    `Google: https://g.page/r/loanclosingagent/review\n` +
    `Yelp: https://www.yelp.com/biz/loan-closing-agent\n\n` +
    `Reply STOP to opt out.`
  )
}

// ── 5. Admin alert SMS ────────────────────────────────────────
export async function smsAdminAlert({ phone, message }) {
  await sendSMS(phone,
    `🔔 NSV ALERT\n${message}\n\n` +
    `Reply STOP to opt out.`
  )
}

// ── 6. Notary credential upload reminder ─────────────────────
export async function smsCredentialUpload({ notary_name, notary_phone }) {
  await sendSMS(notary_phone,
    `📋 NSV — Action Required\n` +
    `Hi ${notary_name}!! Please upload your credentials to activate your account!!\n\n` +
    `https://notarysigningvault.com/notary/credentials\n\n` +
    `Reply STOP to opt out.`
  )
}

// ── 7. Appointment confirmed — borrower notification ─────────
export async function smsAppointmentConfirmed({ client_phone, notary_name, job_number, appointment }) {
  await sendSMS(client_phone,
    `☎️ Appointment Confirmed — ${job_number}\n` +
    `${notary_name || 'Your NSV notary'} has confirmed your signing!!\n` +
    `Appointment: ${appointment || 'See portal'}\n\n` +
    `Track your order:\nhttps://notarysigningvault.com/client\n\n` +
    `Reply STOP to opt out.`
  )
}

// ── 8. Notary arrived — borrower notification ────────────────
export async function smsNotaryArrived({ client_phone, notary_name, job_number }) {
  await sendSMS(client_phone,
    `📍 Notary Arrived — ${job_number}\n` +
    `${notary_name || 'Your NSV notary'} has arrived at the appointment location!!\n` +
    `Your signing is in progress!!\n\n` +
    `Reply STOP to opt out.`
  )
}
